export default __webpack_public_path__ + "assets/models/7e07f15c0d2dc2c84376e245e688c1d3.glb";